// Keep IDs stable when changing display names or network addresses.
export const nfcServers = [
    {
        id: 'printserver',
        name: 'Pi 01',
        urls: ['wss://192.168.1.38:3000', 'wss://printserver.home:3000'],
        ports: ['1.1', '1.2', '1.3', '1.4'],
    },
    {
        id: 'pi-02',
        name: 'Pi 02',
        urls: ['wss://192.168.1.32:3000'],
        // Pi 3B+ exposes two sockets through its nested USB hub.
        // Array order defines the user-facing port numbers; values remain USB paths.
        ports: ['1.1.2', '1.2', '1.3', '1.1.3'],
    },
]

const legacyPorts = {
    'Isaure (port 1.1)': '1.1',
    'Ezekiel (port 1.4)': '1.4',
}

export function normalizeNfcSelection(value) {
    return legacyPorts[value] ? `printserver:${legacyPorts[value]}` : value
}

export function getNfcSelection(value) {
    const normalized = normalizeNfcSelection(value)
    for (const server of nfcServers) {
        const port = server.ports.find((port) => normalized === `${server.id}:${port}`)
        if (port) return { server, port }
    }
    return null
}

export function getNfcReaderPort(reader, serverId) {
    if (typeof reader !== 'string') return null
    if (serverId === 'printserver' && legacyPorts[reader]) return legacyPorts[reader]
    return reader.match(/^Port (\d+(?:\.\d+)*)$/)?.[1]
        ?? reader.match(/^1-(\d+(?:\.\d+)*)$/)?.[1]
        ?? null
}

export const nfcReadersSelectItems = [
    { value: 'none', label: 'Pas de lecteur' },
    ...nfcServers.map((server) => ({
        group: server.name,
        items: server.ports.map((port, index) => ({
            value: `${server.id}:${port}`,
            label: `${server.name} - Port ${index + 1}`,
        })),
    })),
]
